/**
 * cookies.js
 */
import { CookieCutter, GoogleAnalyticsCookie } from 'cookiecutter';

declare global {
    interface Window { 
        ga_id: string;
    }
}

export class Cookies {

    constructor() {

        // Setup
        const cookies = new CookieCutter({
            policyText: 'View our cookie policy.',
            policyURL: '/cookie-policy/',
        });
    
        // Manually add Google Analytics
        cookies.add(GoogleAnalyticsCookie(window.ga_id));
    
        // Ask
        cookies.request();
    }
}
